import type { RouterHook } from '@/types/router/router-hook.type'
import { useBreadcrumbStore } from '@/stores/breadcrumb.store'

export const breadcrumbHook: RouterHook = {
  beforeEachAuthenticated: async (to) => {
    const breadcrumbStore = useBreadcrumbStore()

    const settings = {
      visible: true,
      shouldClear: true,
      ...to.meta.breadcrumb,
    }

    if (settings.shouldClear) {
      // Clear the breadcrumb between navigations to maintain breadcrumb stability.
      breadcrumbStore.resetBreadcrumbs()
    }

    breadcrumbStore.setVisible(settings.visible)
  },
}
